// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");

function LongTextEditor(props) {
  var onLongTextChange = props.onLongTextChange;
  var longText = props.longText;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Placeholder",
                              className: "text-darkcharcoal text-sm mb-2 font-medium"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full",
                              placeholder: "Placeholder",
                              type: "text",
                              value: LongText$ReactHooksTemplate.placeholder(longText),
                              onChange: (function ($$event) {
                                  Curry._1(onLongTextChange, LongText$ReactHooksTemplate.setPlaceholder(longText, Utils$ReactHooksTemplate.formTargetValue($$event)));
                                })
                            })
                      ],
                      className: "mb-4"
                    })
              ]
            });
}

var make = LongTextEditor;

exports.make = make;
/* react/jsx-runtime Not a pure module */
